// danceStylesData.ts
export interface DanceStyle {
  id: number;
  name: string;
  parent: number | null;
  isUmbrella: boolean;
}

export const danceStyles: DanceStyle[] = [
  // Kizomba umbrella
  { id: 1, name: "Kizomba", parent: null, isUmbrella: true },
  { id: 2, name: "Urbankiz", parent: 1, isUmbrella: false },
  { id: 3, name: "Semba", parent: 1, isUmbrella: false },
  { id: 4, name: "Tarraxinha", parent: 1, isUmbrella: false },

  // Swing umbrella
  { id: 5, name: "Swing", parent: null, isUmbrella: true },
  { id: 6, name: "Lindy Hop", parent: 5, isUmbrella: false },
  { id: 7, name: "East Coast Swing", parent: 5, isUmbrella: false },
  { id: 8, name: "West Coast Swing", parent: 5, isUmbrella: false },

  // Salsa umbrella
  { id: 9, name: "Salsa", parent: null, isUmbrella: true },
  { id: 10, name: "Cuban Salsa", parent: 9, isUmbrella: false },
  { id: 11, name: "LA Style", parent: 9, isUmbrella: false },
  { id: 12, name: "NY Style", parent: 9, isUmbrella: false },

  // Standalone
  { id: 13, name: "Fusion", parent: null, isUmbrella: false },
  { id: 14, name: "Brazilian Zouk", parent: null, isUmbrella: false },
  { id: 15, name: "Caribbean Zouk", parent: null, isUmbrella: false },
];
